import { render, staticRenderFns } from "./Payer.vue?vue&type=template&id=fe7d1e4e"
import script from "./Payer.vue?vue&type=script&lang=js"
export * from "./Payer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports